import { WEIGHT_UNIT } from '../../../../../../types/enum';

const WeightUnit = ({ icon = null, preference, updateUserPreference }) => {
  const handleChangeWeightUnit = async () => {
    await updateUserPreference({
      weightUnit:
        preference.weightUnit === WEIGHT_UNIT.KG
          ? WEIGHT_UNIT.LB
          : WEIGHT_UNIT.KG,
    });
  };

  return (
    <div className='flex items-center gap-2 py-4 border-b'>
      <div className='flex-1'>
        <div className='flex items-center gap-1'>
          {icon}
          <h2 className='text-sm font-semibold text-gray-900'>Weight Unit</h2>
        </div>
        <p className='text-sm text-gray-500'>
          Choose the unit of weight that you want to use.
        </p>
      </div>
      <div>
        <div className='flex items-center gap-2'>
          <span className='text-sm text-gray-500'>lb</span>
          <button
            type='button'
            role='switch'
            aria-checked={preference.weightUnit === WEIGHT_UNIT.KG}
            onClick={handleChangeWeightUnit}
            className={`${
              preference.weightUnit === WEIGHT_UNIT.KG
                ? 'bg-black'
                : 'bg-gray-200'
            } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2`}
          >
            <span
              aria-hidden='true'
              className={`${
                preference.weightUnit === WEIGHT_UNIT.KG
                  ? 'translate-x-5'
                  : 'translate-x-0'
              } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
            />
          </button>
          <span className='text-sm text-gray-500'>kg</span>
        </div>
        <div className='text-xs text-gray-500 mt-1'>1kg = 2.20462lb</div>
      </div>
    </div>
  );
};

export default WeightUnit;
